import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * i18n strings pushed to the CRE PiP (`mirror-state.labels` + toasts).
 */
export function useCreMirrorLabels() {
  const { t } = useTranslation("common");

  return useMemo(
    () => ({
      reportAudio: t("reportAudio"),
      dictateHere: t("dictateYourFindingsHere"),
      transcription: t("sidebarTranscriptionHeading"),
      findingsPlaceholder: t("findingsPlaceholder"),
      listening: "Listening...",
      contentCopied: t("contentCopiedToClipboard"),
      copyFailed: t("failedToCopyContent"),
      floatOpenFailed: t("creFloatingDictationFailed"),
      patientNameLabel: t("creFloatingPatientNameLabel"),
      accessionLabel: t("creFloatingAccessionLabel"),
      genderLabel: t("creFloatingGenderLabel"),
      processReportButton: t("processReportButton"),
      copyReportButton: t("copyReportButton"),
      sidebarCommandModeToggleLabel: t("sidebarCommandModeToggleLabel"),
      selectTemplate: t("creFloatingSelectTemplate", {
        defaultValue: t("chatSelectTemplate"),
      }),
      selectTemplatePlaceholder: t("chatSelectTemplatePlaceholder", {
        defaultValue: "Choose a template...",
      }),
      templatesEmpty: t("appendTemplateEmptyText", {
        defaultValue: "No templates available.",
      }),
      templatesEmptySearch: t("appendTemplateEmptySearchText", {
        defaultValue: "No templates match your search.",
      }),
      newPatientReportButton: t("newPatientReport"),
    }),
    [t],
  );
}
